import { FC } from 'react';
import { Icons } from '@silverfort/sf-components';
import CloudFrame from '../../../CloudFrame/CloudFrame';
import MessagePage from '../../../Controls/GenericMessagePage/MessagePage';

const CloudIntegrationsFallback = () => (
    <MessagePage
        icon={Icons.CloudOff}
        bigMsg="Partial Connection"
        smallMsgs={[
            'Could not connect you to cloud services at the moment.',
            'You can still use Silverfort without cloud abilities.'
        ]}
        darkMode={false}
        hasWrapper={true}
    />
);

const CloudIntegrations: FC = () => (
    <CloudFrame
        srcRoute={'/silverfort/v1/integrations'}
        fallback={<CloudIntegrationsFallback />}
        className="w-full h-full overflow-hidden"
    />
);

export default CloudIntegrations;
